module.exports = __webpack_public_path__ + "static/media/ThankYouCompany.f006cbed.png";